module.exports = __webpack_public_path__ + "img/success.d66028e5.png";